import React ,{ useState, useEffect } from 'react';
import style from '@/modules/pain-points/components/left-filter-navigate/common.module.scss';
import CollapseItem from './collapseItem.jsx';
import FilterSelect from './filterSelect.jsx';
import { painPointGetDetail, painPointGetList,getFilterMenu } from '@/modules/pain-points/api/request';
import EventBus from '@/modules/pain-points/hooks/eventBus';

const App = ({ onFilterChange }) => {
  const [dishType, setDishType] = useState([]);
  const [subType, setSubType] = useState([]);
  const [generation, setGeneration] = useState([]);
  const [lifeStage, setLifeStage] = useState([]);
  const [markets, setMarkets] = useState([]);
  const [needStates, setNeedStates] = useState([]);
  const [frequencyOfConsumption, setFrequencyOfConsumption] = useState([]);
  const [contemporaryCooks, setContemporaryCooks] = useState([]);
  const [themes, setThemes] = useState([]);
  const [showDishType, setShowDishType] = useState([]);
  const [showThemes, setShowThemes] = useState([]);
  const [selectedFilter, setSelectedFilter] = useState({
    market: 'Germany',
    dishType: 'Pasta',
    subType: '',
    needStates: '',
    generation: '',
    lifeStage: '',
    frequencyOfConsumption: '',
    contemporaryCooks: '',
    themes: '',
  });
  const formatOptions = (opts) => {
    if (!opts) return [];
    
    // 如果 options 是字符串数组，转换为正确的格式
    if (typeof opts === 'string') {
      return [{ value: opts, label: opts }];
    }
    
    if (Array.isArray(opts)) {
      return opts.map(opt => {
        if (typeof opt === 'string') {
          return { value: opt, label: opt };
        }
        return opt;
      });
    }
    
    return [];
  };
  useEffect(() => {
    getFilterMenu()
      .then(res => {
        let tempDishType = res.data.dishType.filter(item => item.market === 'Germany');
        let tempThemes = res.data.themes.filter(item => item.market === 'Germany');
        setShowDishType(tempDishType);
        setShowThemes(tempThemes);
        // setDishType(formatOptions(res.data.dishType[0].typeName));
        setDishType(formatOptions(tempDishType.map(item => {return item.typeName[0]})));
        setSubType(formatOptions(res.data.dishType[0].subType));
        setGeneration(formatOptions(res.data.demographics.generation));
        setLifeStage(formatOptions(res.data.demographics.lifeStage));
        setMarkets(formatOptions(res.data.markets));
        setNeedStates(formatOptions(res.data.needStates));
        setFrequencyOfConsumption(formatOptions(res.data.frequencyOfConsumption));
        setContemporaryCooks(formatOptions(res.data.contemporaryCooks));
        setThemes(formatOptions(res.data.themes[0].themes));
        // onFilterChange?.(selectedFilter);
        EventBus.dispatchEvent('sendFilterData', selectedFilter);
      })
      .catch(err => {
        console.error('getFilterMenu error:', err);
      });
  }, []);

  useEffect(() => {
    // 添加重置事件监听
    EventBus.addEventListener('resetAllFilters', handleResetAll);
    
    return () => {
      EventBus.removeEventListener('resetAllFilters', handleResetAll);
    };
  }, []);

  const handleResetAll = () => {
    const resetValues = {
      market: 'Germany',
      dishType: 'Pasta',
      subType: '',
      needStates: '',
      generation: '',
      lifeStage: '',
      frequencyOfConsumption: '',
      contemporaryCooks: '',
      themes: '',
    };
    setSelectedFilter(resetValues);
    // onFilterChange?.(resetValues); // 使用新的重置值而不是旧的 state
    EventBus.dispatchEvent('resetFilterData', resetValues);
  };

  const renameKey = (typeName) => {
    switch(typeName) {
      case 'Dish Type':
        return 'dishType';
      case 'Sub Type':
        return 'subType';
      case 'Generation':
        return 'generation';
      case 'Life Stage':
        return 'lifeStage';
      case 'Occasions':
        return 'needStates';
      case 'Need Grouping':
        return 'themes';
      case 'Frequency of Consumption':
        return 'frequencyOfConsumption';
      case 'Contemporary Cooks':
        return 'contemporaryCooks';
      default:
        return typeName;
    }
  }
  const handleFilterChange = (data) => {
    const { value, type } = data;
    if(type === 'Dish Type') {
      const resetValues = {
        market: 'Germany',
        dishType: value,
        subType: '',
        needStates: '',
        generation: '',
        lifeStage: '',
        frequencyOfConsumption: '',
        contemporaryCooks: '',
        themes: '',
      };
      setSelectedFilter(resetValues);
      setSubType(formatOptions(showDishType.filter(item => item.typeName[0] === value)[0]['subType']));
      setThemes(formatOptions(showThemes.filter(item => item.typeName === value)[0]['themes']));
    } else {
      setSelectedFilter(prevValues => ({
        ...prevValues,
        [renameKey(type)]: value
      }));
    }
  };

  useEffect(() => {
    onFilterChange?.(selectedFilter);
  }, [selectedFilter, onFilterChange]);

  const items = [{
    key: '2',
    label: 'Dish Type',
    children: <div>
      <FilterSelect title="Dish Type" options={dishType} defaultValue={'Pasta'} onChange={handleFilterChange} allowClear={false} value={selectedFilter.dishType}/>
      <FilterSelect title="Sub Type" options={subType} onChange={handleFilterChange} allowClear={true} value={selectedFilter.subType}/>
    </div>,
  }, {
    key: '4',
    label: 'Demographics',
    children: <div>
      <FilterSelect title="Generation" options={generation} onChange={handleFilterChange} allowClear={true} value={selectedFilter.generation}/>
      <FilterSelect title="Life Stage" options={lifeStage} onChange={handleFilterChange} allowClear={true} value={selectedFilter.lifeStage}/>
    </div>,
    },
  ];

  return <>
    <div className={style.selectBox}>
        <FilterSelect 
          title="Market" 
          options={markets} 
          defaultValue={'Germany'}
          onChange={handleFilterChange}
          allowClear={false}
          value={selectedFilter.market}
        />
    </div>
    <div className={style.line} />
    <CollapseItem item={items[0]} />
    <div className={style.line} />
    <div className={style.selectBox}>
      <FilterSelect title="Occasions" options={needStates} onChange={handleFilterChange} allowClear={true} value={selectedFilter.needStates}/>
    </div>
    <div className={style.selectBox}>
      <FilterSelect title="Need Grouping" options={themes} onChange={handleFilterChange} allowClear={true} value={selectedFilter.themes}/>
    </div>
    <div className={style.line} />
    <CollapseItem item={items[1]} />
    <div className={style.line} />
    <div className={style.selectBox}>
      <FilterSelect title="Frequency of Consumption" options={frequencyOfConsumption} onChange={handleFilterChange} allowClear={true} value={selectedFilter.frequencyOfConsumption}/>
    </div>
    <div className={style.line} />
    <div className={style.selectBox}>
      <FilterSelect title="Contemporary Cooks" options={contemporaryCooks} onChange={handleFilterChange} allowClear={true} value={selectedFilter.contemporaryCooks}/>
    </div>
    <div className={style.line} />
  </>;
};

export default App;